import React from "react";


const SearchIcon = props => {

    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="19.519" height="19.519" viewBox="0 0 19.519 19.519">
            <g id="magnifying-glass--glass-search-magnifying" transform="translate(0.25 0.25)">
                <path id="Vector" d="M7.992,15.484A7.492,7.492,0,1,0,.5,7.992,7.492,7.492,0,0,0,7.992,15.484Z" fill="none" stroke="#5c6884" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" />
                <path id="Vector_2" d="M14.768,14.768,10,10" transform="translate(3.44 3.44)" fill="none" stroke="#5c6884" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" />
            </g>
        </svg>
    );

}

export default SearchIcon;